import { handleChipColor, handleChipText, handleCustomChipColor } from '../helpers/helpers';
import { ColumnCellTemplateData } from 'devextreme/ui/data_grid';
import CustomChip from 'src/@core/components/mui/chip';
import CustomToggle from '../components/CustomToggle';
import { Box, Typography } from '@mui/material';
import { NewColumn } from '../datagrid-types';
import { format } from 'date-fns';
import Link from 'next/link';

/**
 * Parses an array of NewColumn objects and modifies their customType property if it matches certain values.
 * Also adds a cellRender function to the NewColumn object based on its customType property.
 * @param columns - An array of NewColumn objects to be parsed.
 * @returns An array of modified NewColumn objects.
 */
const parseAnyPredifinedCustomColumns = (columns: NewColumn[]): NewColumn[] => {
  return columns.map((column: NewColumn) => {
    const isTime = column.customType === 'time';
    // if (isTime) {
    //   column.customType = 'string';
    // }

    const isETA = column.customType === 'ETA';
    // if (isETA) {
    //   column.customType = 'string';
    // }

    const isToggle = column.customType === 'toggle';
    // if (isToggle) {
    //   column.customType = 'boolean';
    // }

    return {
      ...column,
      ...(column.customType === 'number' && { alignment: 'left' }),
      ...(column.customType === 'chip' && {
        customType: 'string',
        cellRender: ({ row }: ColumnCellTemplateData) => (
          <CustomChip
            skin="light"
            size={column.chipOptions?.size}
            label={handleChipText(column, row)}
            color={handleChipColor(column, row)}
            sx={{
              textTransform: 'capitalize',
              ...(column?.chipOptions?.customColorOverride && { backgroundColor: handleCustomChipColor(column, row) })
            }}
          />
        )
      }),
      ...(column?.customType &&
        ((column.customType !== 'chip' && column.customType !== 'boolean' && !column.cellRender) || isToggle) && {
          cellRender: ({ value = '', row }: ColumnCellTemplateData) => (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                {column.route && (
                  <Typography
                    noWrap
                    component={Link}
                    href={column.route || '#'}
                    variant="body2"
                    sx={{ ...column.fieldStyles, fontWeight: 600, color: 'text.primary', textDecoration: 'none' }}>
                    {value}
                  </Typography>
                )}

                {!column.route && column.customType !== 'dateTime' && !isTime && !isETA && (
                  <Typography noWrap component="a" variant="body2" sx={{ ...column.fieldStyles }}>
                    {value instanceof Date ? value.toLocaleDateString() : value ?? ''}
                  </Typography>
                )}

                {column.customType === 'dateTime' && value && value != '' && (
                  <Typography noWrap component="a" variant="body2" sx={{ ...column.fieldStyles }}>
                    {format(new Date(value), 'dd/MM/yy')}
                  </Typography>
                )}

                {isTime && value && value != '' && (
                  <Typography noWrap component="a" variant="body2" sx={{ ...column.fieldStyles }}>
                    {new Date(value).toLocaleTimeString().substring(0, 5)}
                  </Typography>
                )}

                {isToggle && (
                  <CustomToggle
                    fieldStyles={column.fieldStyles}
                    updateCallback={column.updateCallback}
                    row={row}
                    col={column}
                  />
                )}

                {isETA && value && value != '' && (
                  <>
                    <Typography noWrap component="a" variant="body2" sx={{ ...column.fieldStyles }}>
                      {new Date(value).toLocaleTimeString().substring(0, 5)}
                    </Typography>
                    <Typography
                      noWrap
                      component="a"
                      variant="caption"
                      sx={{ ...column.fieldLine2Styles, textDecoration: 'none' }}>
                      {format(new Date(value), 'dd/MM/yy')}
                    </Typography>
                  </>
                )}

                {column.fieldLine2 && (
                  <Typography
                    noWrap
                    component="a"
                    variant="caption"
                    sx={{ ...column.fieldLine2Styles, textDecoration: 'none' }}>
                    {column.fieldLine2}
                  </Typography>
                )}
              </Box>
            </Box>
          )
        })
    };
  });
};

export default parseAnyPredifinedCustomColumns;
